import { render, staticRenderFns } from "./ResourceScroller.ModelBox.vue?vue&type=template&id=014275d8&scoped=true&"
import script from "./ResourceScroller.ModelBox.vue?vue&type=script&lang=js&"
export * from "./ResourceScroller.ModelBox.vue?vue&type=script&lang=js&"
import style0 from "./ResourceScroller.ModelBox.vue?vue&type=style&index=0&id=014275d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014275d8",
  null
  
)

export default component.exports